import {
  alpha,
  makeStyles,
} from '@material-ui/core';

export default makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  error: {
    color: theme.palette.error.main,
  },
  errorBg: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.error.main, 0.7),
    },
  },
  filterCard: {
    marginBottom: theme.spacing(2),
  },
  paperFilter: {
    marginBottom: theme.spacing(2),
    boxShadow: 'none !important',
  },
  cardFilter: {
    boxShadow: 'none !important',
  },
  cardContentFilter: {
    paddingLeft: '5px !important',
    paddingRight: '5px !important',
  },
  footerSeparator: {
    backgroundColor: theme.palette.secondary.main,
    padding: '2px',
  },
  primary: {
    color: theme.palette.primary.main,
  },
  primaryBg: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.7),
    },
  },
  secondary: {
    color: theme.palette.secondary.main,
  },
  secondaryBg: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.secondary.main, 0.7),
    },
  },
  success: {
    color: theme.palette.success.main,
  },
  successBg: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.success.main, 0.7),
    },
  },
  warning: {
    color: theme.palette.warning.main,
  },
  warningBg: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.warning.main, 0.7),
    },
  },
  customInput: {
    '& .MuiInput-underline:before': {
      borderBottomColor: '#3C89E4',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#3C89E4',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px',
      '& fieldset': {
        borderColor: '#3C89E4',
      },
      '&:hover fieldset': {
        borderColor: '#3C89E4',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3C89E4',
      },
    },
  },
  customTable: {
    border: 'none !important',
    '& > thead': {
      border: 'none !important',
    },
  },
  tableHeader: {
    fontSize: '32px !important',
    fontStyle: 'normal',
    color: '#0C3A72',
    '& > span': {
      fontSize: '32px !important',
      color: '#0C3A72',
    },
  },
  customCell: {
    backgroundColor: '#FFFFFF !important',
    color: '#71747D !important',
    paddingLeft: '10px',
    borderBottom: '1px solid #F2F2F2 !important',
  },
  customTablebody: {
    backgroundColor: '#FFF !important',
    '& > tr': {
      backgroundColor: '#FFF !important',
      borderBottom: '1px solid #F2F2F2 !important',
    },
  },
  customRows: {
    paddingLeft: '8px !important',
    color: '#71747D',
  },
  customButton: {
    backgroundColor: 'rgba(206, 225, 248, 0.5) !important',
    color: '#0C3A72 !important',
    boxShadow: 'none !important',
    fontFamily: 'Helvetica',
    fontStyle: 'normal',
    fontSize: '10px',
    borderRadius: '5px',
  },
  contSVG: {
    borderRadius: '50%',
    borde: 'none',
    background: '#0C3A72 !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '32px',
    height: '32px',
  },
  whiteIcon: {
    color: 'white !important',
  },
}));
